import { render, staticRenderFns } from "./WaveForm.vue?vue&type=template&id=bc237000&scoped=true&"
import script from "./WaveForm.vue?vue&type=script&lang=js&"
export * from "./WaveForm.vue?vue&type=script&lang=js&"
import style0 from "./WaveForm.vue?vue&type=style&index=0&id=bc237000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc237000",
  null
  
)

export default component.exports